import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AlertService } from "./alert.service";
import { firstValueFrom } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
	providedIn: "root"
})
export class AnnouncementService {
	private basePath: string = `${environment.url}/api/Announcement/`;

	constructor(private http: HttpClient, private alertService: AlertService) {}

	async getAnnouncement(): Promise<any> {
		let response: any;

		try {
			response = await firstValueFrom(
				this.http.get<any>(`${this.basePath}GetAnnouncement`)
			);
		} catch (error) {
			this.alertService.openSnackBar("Failed to retrieve announcement");
			throw new Error();
		}

		return response;
	}
}

export interface AnnouncementData {
	isExist: boolean;
	title: string;
	description: string;
}
